<template lang="pug">
  .listTab01
    section.tabRule
    section.tabRule1
    section.tabRule2
    section.tabRuleInfo
      header
      .tabRuleInner
        ol.items
          li
            p 活动时间，依北京时间为主。
          li
            p 凡娱乐城会员在指定活动日期间，不须额外报名，只要玩「JDB 财神捕鱼、五龙捕鱼」之玩家，都可以参与本活动。
          li
            p 若财神榜，五龙榜，同时有两名（超过）玩家捕获次数相同，则依当日押码量进行排名。若捕获次数与当日累积押码量相同，则依当日累积押码量之最后统计时间排序。
          li
            p 累计押码量，最多统计于小数点两位数。
        ol.items(start=5)
          li
            p 所有奖金无需申请，系统将于结算当日下午17:00前完成派彩，将自动派发送到会员账户，请注意额度变化。
          li
            p 娱乐城保有优惠活动最终解释权，若有任何疑问，请联络娱乐城在线客服。
          li
            p 如遇特殊状况，本公司保有修改、变更或暂停本活动之权利。
          li
            p 本活动所产生的任何相关异议及问题，本公司保有最终解释权。
</template>
<script>
import moment from 'moment'
moment.locale('zh-CN')
export default {
  props: ['campaign'],
  methods: {
    formatDateLLL (val) {
      return moment(val).format('LLLL')
    }
  }
}
</script>

<style lang="scss">
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
@import '../assets/styles/base/base';
@import '../assets/styles/base/table';

.listTab01 {
  section {
    margin-bottom: 3em;
  }
}
.tabRule {
  width: 100%;
  padding-top: calc(100% * 660 / 425);
  background: url('../assets/images/content1_m.png') no-repeat center center;
  background-size: contain;
  @include breakpoint(1024px){
    padding-top: calc(100% * 560 / 980);
    background: url('../assets/images/content1_p.png') no-repeat center center;
  }
}

.tabRule1 {
  width: 100%;
  padding-top: calc(100% * 1370 / 425);
  background: url('../assets/images/content2_m.png') no-repeat center center;
  background-size: contain;
  @include breakpoint(1024px){
    padding-top: calc(100% * 940 / 980);
    background: url('../assets/images/content2_p.png') no-repeat center center;
  }
}

.tabRule2 {
  width: 100%;
  padding-top: calc(100% * 705 / 425);
  background: url('../assets/images/content3_m.png') no-repeat center center;
  background-size: contain;
  @include breakpoint(1024px){
    padding-top: calc(100% * 620 / 980);
    background: url('../assets/images/content3_p.png') no-repeat center center;
  }
}

.tabRuleInfo {
  width: 100%;
  header {
    width: 100%;
    padding-top: calc(100% * 55 / 425);
    background: url('../assets/images/tabRuleInfo_m.png') no-repeat center center;
    background-size: contain;
    @include breakpoint(1024px){
      background: url('../assets/images/tabRuleInfo_p.png') no-repeat center center;
    }
  }
  .tabRuleInner {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    padding: 0px 25px;
    box-sizing: border-box;
    @include breakpoint(1024px) {
      flex-direction: row;
    }
    .items {
      margin: 0;
      padding-left: 2.5em;
      box-sizing: border-box;
      flex-basis: 100%;
      list-style-type: decimal-leading-zero;
      @include breakpoint(1024px) {
        flex-basis: calc(100% / 2 - 30px);
        margin: 0 auto;
      }
      li {
        color: $black;
        font-weight: bold;
        @include rem(font-size, 1.5rem);
        p {
          color: $black;
          line-height: 2;
          text-align: justify;
          @include rem(font-size, 1.5rem);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ruleBoard.vue